interface TikTokIconProps {
  size?: number;
  className?: string;
}

export function TikTokIcon({ size = 20, className = "" }: TikTokIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.975-1.188-2.169-1.188-3.338v-.002c0-.007 0-.013-.001-.02H13.64v11.12c0 .07 0 .14-.003.209-.024 1.337-1.133 2.408-2.485 2.408-1.375 0-2.491-1.117-2.491-2.491 0-1.375 1.116-2.492 2.491-2.492.207 0 .408.026.6.075v-2.904c-.188-.025-.381-.04-.576-.04-2.966 0-5.373 2.407-5.373 5.373 0 2.966 2.407 5.373 5.373 5.373 2.966 0 5.373-2.407 5.373-5.373V7.251a8.126 8.126 0 0 0 4.756 1.533V5.856c-.84 0-1.635-.214-2.326-.588-.226-.123-.443-.258-.657-.407z"/>
    </svg>
  );
}